import React from "react";

interface Props {
  handleConfirmar: (event: React.FormEvent<HTMLFormElement>) => void;
}

const ButtonGroup: React.FC<Props> = ({ handleConfirmar }) => {
  return (
    <div className="row">
      <div className="row align-items-center">
        <form className="mb-3" onSubmit={handleConfirmar}>
          <div className="row">
            <div className="col">
              <div className="d-flex justify-content-end mt-5">
                <a
                  className="btn btn-outline-danger me-2 btn-sm"
                  href="/milshop"
                  role="button"
                  style={{ width: "100px" }}
                >
                  Cancelar
                </a>
                <button
                  type="submit"
                  className="btn btn-outline-primary btn-sm"
                  style={{ width: "100px" }}
                >
                  Incluir
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
export default ButtonGroup;
